import { React, useState, useContext, useEffect } from 'react';
import { AccountContext } from '../Accounts'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
  NavBtnLink
} from './SigninElements';


const SignIn = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const { authenticate, getSession, logout } = useContext(AccountContext);

  useEffect(() => {
    getSession()
      .then(session => {
        setStatus(true);
      })
      .catch(err => console.log(err))
  }, []);

  const signIn = event => {
    event.preventDefault();
    const userCredentials = {
      username: email,
      pwd: password
    }
    authenticate(userCredentials)
      .then(data => {
        console.log('Logged in!', data);
        navigate(from, { replace: true });
      })
      .catch(err => {
        console.error('Failed to login!', err);
        setSubmitStatus(false)
      })
  };

  const handleLogoutClick = async (event) => {
    event.preventDefault();
    await logout();
  };

  return (
    <>
      <Container>
        <FormWrap>
          {status ? (
            <FormContent>
              <Form action="#" onSubmit={handleLogoutClick}>
                <FormH1>Are you sure you want to sign out?</FormH1>
                <FormButton type="submit">Sign Out</FormButton>
              </Form>
            </FormContent>
          ) :
            <FormContent>
              <Form action='#'>
                <FormH1>Sign in to your account</FormH1>
                <FormLabel htmlFor='for'>Username</FormLabel>
                <FormInput type='email' value={email} onChange={event => setEmail(event.target.value)} required />
                <FormLabel htmlFor='for'>Password</FormLabel>
                <FormInput type='password' value={password} onChange={event => setPassword(event.target.value)} required />
                {submitStatus ? (
                  <FormButton type='submit' onClick={signIn}>Sign In</FormButton>
                ) :
                  <FormButton type='submit' onClick={signIn}>Log in issue, please try again</FormButton>
                }
                <Text></Text>
                <NavBtnLink to='/reset'>Password Reset</NavBtnLink>
                <Text></Text>
                <NavBtnLink to='/signup'>Sign Up</NavBtnLink>
              </Form>
            </FormContent>
          }
        </FormWrap>
      </Container>
    </>
  );
};

export default SignIn;
